import { PronosticoHistoricoElementAPI } from '@/domain/entities/Api'
import { Commit } from '@/store/types'
import { getEnvironments } from '@/environments'
import { client as fetch } from './ClientService'

export interface PronosticoHistoricoInterface {
  getPronosticoHistorico(): Promise<Commit<PronosticoHistoricoElementAPI[]>>
  getLinkDescarga(estacionId: number, fecha: string): Promise<Commit<string>>
}

export class PronosticoHistoricoService implements PronosticoHistoricoInterface {
  env = getEnvironments()
  apiUrl: string = this.env.url.API ? this.env.url.API : window.location.origin
  resumen: number = this.env.settings.PRONOSTICO_HIDRICO.resumen ? this.env.settings.PRONOSTICO_HIDRICO.resumen : 2;
  constructor (apiUrl?: string) {
    this.apiUrl = apiUrl || this.apiUrl
  }
  async getPronosticoHistorico (): Promise<Commit<PronosticoHistoricoElementAPI[]>> {
    try {
      const response = await fetch(`${this.apiUrl}/api/pronostico_historico_aa`)
      console.log(response)
      return { type: 'PRONOSTICO_HISTORICO_FETCHED', payload: response }
    } catch (e) {
      return { type: 'PRONOSTICO_HISTORICO_ERROR', payload: e }
    }
  }
  async getLinkDescarga (estacionId: number, fecha: string): Promise<Commit<string>> {
    const api = `${this.generateAPI(estacionId, fecha)}`
    return { type: 'PRONOSTICO_HISTORICO_SET_API_DESCARGA', payload: api }
  }
  generateAPI (estacionId: number, fecha: string): string {
    return `${this.apiUrl}/api/pronostico_historico_aa/${estacionId}/${fecha}`
  }
}
